import { createGlobalStyle } from 'styled-components'
// eslint-disable-next-line import/no-unresolved
import { PancakeTheme } from '@pancakeswap/uikit/dist/theme'
import { darken } from '@mui/material'
// import { alpha } from '@mui/material/styles'

declare module 'styled-components' {
  /* eslint-disable @typescript-eslint/no-empty-interface */
  export interface DefaultTheme extends PancakeTheme {}
}

const cssXaoShadow = `none;`

const GlobalStyle = createGlobalStyle`
  * {
    font-family: 'Urbanist', sans-serif;
  }
  body {
    background-color: ${({ theme }) => theme.colors.background};
    overflow-x: hidden !important;

    img {
      height: auto;
      max-width: 100%;
    }
  }

  #root::before {
    display: block;
    content: '';
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    height: 100%; 
    background: ${({ theme }) => theme.colors.background};
    // background: url(/images/bg.jpg) no-repeat;
    background-position: center top;
    background-size: 100% 100%;

    @media (max-width: 575px) {
      background: ${({ theme }) => theme.colors.background};
      // background-image: url(/images/bg-mobile.jpg);
    }
  }

  .no-border {
    border: 0!important;
  }

  .border-xao {
    border: 1px solid ${({ theme }) => theme.colors.cardBorder};
    box-shadow: 0 0 12px 2px ${({ theme }) => theme.colors.cardBorder};
    padding-right: 2px;
  }
  .border-gray {
    border: 2px solid ${({ theme }) => theme.colors.cardBorder};
    border-radius: 10px;
  }

  .bg-transparent {
    background: transparent!important;
  }
  .bg-xao {
    border: 1px solid transparent !important;
    background: ${({ theme }) => theme.colors.primary} !important;
  }
  .hover-xao-bg:not([disabled]):not(.disabled):hover {
    background-color: ${({ theme }) => darken(theme.colors.primary, 0.1)};
  }
  .shadow-xao {
    ${cssXaoShadow}
  }
  .btn-xao {
    color: #fff;
    background-color: ${({ theme }) => theme.colors.primary};
    font-weight: 400;
    box-shadow: none;
  }
  .btn-xao-normal {
    color: ${({ theme }) => theme.colors.text};
    background-color: transparent;
    border-color: ${({ theme }) => theme.colors.textDisabled};
    box-shadow: none;
  }
  .btn-xao-sm {    
    color: ${({ theme }) => theme.colors.text};
    border: 1px solid ${({ theme }) => theme.colors.textDisabled};;
    border-radius: 4px;
    padding: 4px 15px;
    background: ${({ theme }) => theme.colors.background};
    font-weight: 400;
    // font-size: 14px;
    min-height: 32px;
    letter-spacing: normal;
  }
  .btn-xao-md {
    border: 1px solid ${({ theme }) => theme.colors.cardBorder}!important;
    border-radius: 6px !important;
    padding: 7px 15px;
    gap: 5px;
    height: 36px;
    // font-size: 16px;
    min-height: 30px;
    letter-spacing: normal;
    min-width: 120px;
    color: ${({ theme }) => theme.colors.text};
    font-family: 'Urbanist', serif;
    transition: .3s;
    :hover{      
      border-color: ${({ theme }) => theme.colors.primary}!important;
    }

    @media (max-width: 575px) {
      min-width: 20px!important;
      border-radius: 5px !important;
    }
  }
  .submenu-item {
    border: 1px solid ${({ theme }) => theme.colors.text};
    justify-content: center;
    width: 200px;
    padding: 13px 20px;
    height: auto;
    border-radius: 10px;
    background: transparent;

    &.active {
      ${cssXaoShadow}
    }

    @media (max-width: 575px) {
      width: 120px;
      font-size: 16px;
      padding: 10px 20px;
    }
  }
  @media (max-width: 575px) {
    .hide-mobile {
      display: none !important;
    }
  }
  @media (min-width: 992px) {
    .hide-desktop {
      display: none !important;
    }
  }
  .btn-user-menu {
    display: flex;
    align-items: center;
    width: 140px;
    height: 32px;
    padding: 0;
    border-radius: 20px 50px 50px 20px;
    color: white; //${({ theme }) => theme.colors.text}!important;
    background: black;
    border: 1px solid ${({ theme }) => theme.colors.cardBorder};
    box-shadow: none;
    &.account-connected {
      width: 155px;
      background: ${({ theme }) => (theme.isDark ? '#1c191f' : '#2b282f')};
    }
    div[title]{
      flex: 1;
      text-align: center;
      font-size: 15px;
      color: white; //${({ theme }) => theme.colors.text}!important;
    }
    :hover{
      border-color: ${({ theme }) => theme.colors.primary};
      opacity: 1;
    }

    .bar {
      display: inline-block;
      width: 0;
      height: 20px;
      border-left: 1px solid transparent;
      margin-left: 0px;
    }

    svg {
      color: white !important; //${({ theme }) => theme.colors.text}!important;
      fill: white !important; //${({ theme }) => theme.colors.text}!important;
    }
  }
  .btn-blue {
    background: #000;
    border: 1px solid ${({ theme }) => theme.colors.cardBorder};
    box-shadow: 0px 0px 12px 8px rgb(36 96 255 / 40%);
    min-width: 140px;
    height: 32px;
    padding: 0px 10px;
    border-radius: 8px;
    font-family: 'Urbanist', serif;
    font-weight: 400;
    font-size: 15px;
    :hover{
      opacity: 1 !important;
      border-color: ${({ theme }) => theme.colors.primary};
    }
  }
  .has-dropdown {
    position: relative;
    &:after {
      content: "";
      position: absolute;
      border-width: 7px 5px 0 5px;
      border-color: #fff transparent transparent transparent;
      border-style: solid;
      top: 50%;
      right: 10px;
      transform: translateY(-50%);
    }
  }
  .border-black {
    border: 1px solid ${({ theme }) => theme.colors.cardBorder};
    box-shadow: 0 0 12px 2px ${({ theme }) => theme.colors.cardBorder};
  }
  #swap-button,
  #join-pool-button,
  #confirm-swap-or-send,
  #confirm-accept-price,
  #btn-swap-connect {
    height: 40px;
    border-radius: 8px;
    // max-width: 320px;
    display: flex;
    background: transparent;
    color: ${({ theme }) => theme.colors.text};
    border: 1.5px solid ${({ theme }) => theme.colors.primary};
    :hover{
      opacity: 1!important;
      color: ${({ theme }) => theme.colors.backgroundAlt2};
      background: ${({ theme }) => theme.colors.primary};
    }
    &.pancake-button--disabled{
      border: 1.5px solid ${({ theme }) => theme.colors.cardBorder};
      background: transparent;
      color: ${({ theme }) => theme.colors.cardBorder};
    }
  }
  #swap-button,
  #btn-swap-connect {
    margin: 25px auto -10px;
  }
  
  input:focus:not(:disabled) {
    box-shadow: none!important;
  }
`

export default GlobalStyle
